import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import termsContent from '../i18n/termsContent';

const TermsOfServicePage = () => {
  const navigate = useNavigate();
  const { language, t } = useLanguage();
  const c = termsContent[language] || termsContent.en;

  return (
    <main className="min-h-screen" style={{ backgroundColor: 'hsl(82, 55%, 95%)' }}>
      <div className="max-w-2xl mx-auto px-4 py-10">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
          style={{ color: 'hsl(143, 28%, 25%)' }}
          data-testid="terms-back-button"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('back')}
        </Button>

        <div className="text-center mb-10">
          <FileText className="w-10 h-10 mx-auto mb-3" style={{ color: 'hsl(143, 28%, 25%)' }} />
          <h1 className="font-display text-3xl sm:text-4xl font-bold mb-2" style={{ color: 'hsl(143, 28%, 25%)' }}>
            {c.title}
          </h1>
          <p className="text-sm" style={{ color: 'hsl(125, 15%, 45%)' }}>{c.effectiveDate}</p>
        </div>

        <div className="space-y-6">
          <P>{c.intro}</P>

          {c.sections.map((section, idx) => (
            <Section key={idx} title={section.title}>
              {section.paragraphs && section.paragraphs.map((p, i) => (
                <P key={i}>{p}</P>
              ))}
              {section.items && (
                <ul className="list-disc pl-5 space-y-1 text-sm" style={{ color: 'hsl(125, 15%, 35%)' }}>
                  {section.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
              {section.afterItems && <P>{section.afterItems}</P>}
            </Section>
          ))}
        </div>
      </div>
    </main>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-semibold text-base mb-2" style={{ color: 'hsl(143, 28%, 25%)' }}>{title}</h2>
    {children}
  </div>
);

const P = ({ children }) => (
  <p className="text-sm leading-relaxed mb-2" style={{ color: 'hsl(125, 15%, 35%)' }}>{children}</p>
);

export default TermsOfServicePage;
